/**
 * LaunchDarkly client-side (browser) configuration for alpha access gating.
 *
 * The client-side ID is public — it ships in the bundle / environment.json like
 * APS PKCE client ids. Flag targeting (allowlisted emails) lives in LaunchDarkly.
 */
import { getApsTier } from "../auth/apsConfig";
import { getConfigValue } from "../config/runtimeConfig";

/** LaunchDarkly boolean flag — email allowlist is configured in the LD console. */
export const ALPHA_FLAG_KEY = "alpha";

export const ALPHA_SUPPORT_MESSAGE =
  "Please reach out to the Forma Code Compliance Support team to give you access to the product alpha version.";

/**
 * Alpha login gating runs only on production APS tier when a client-side ID is
 * configured. Staging and local dev stay open unless explicitly forced on.
 */
export function isAlphaAccessGatingEnabled(): boolean {
  if (getConfigValue("VITE_ALPHA_ACCESS_GATING") === "false") return false;
  if (getApsTier() !== "prd") return false;
  const id = getConfigValue("VITE_LAUNCHDARKLY_CLIENT_SIDE_ID");
  return typeof id === "string" && id.length > 0;
}

export function getLaunchDarklyClientSideId(): string | undefined {
  return getConfigValue("VITE_LAUNCHDARKLY_CLIENT_SIDE_ID");
}

/** Last 4 chars — safe to show in UI when debugging LD environment mismatches. */
export function getLaunchDarklyClientSideIdSuffix(): string | undefined {
  const id = getLaunchDarklyClientSideId();
  return id && id.length >= 4 ? id.slice(-4) : undefined;
}
